const transition = {
  easeCubicIn: "cubic-bezier(0.55, 0.055, 0.675, 0.19)",
  easeCubicOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  easeCubicInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  easeCircIn: "cubic-bezier(0.6, 0.04, 0.98, 0.335)",
  easeCircOut: "cubic-bezier(0.075, 0.82, 0.165, 1)",
  easeCircInOut: "cubic-bezier(0.785, 0.135, 0.15, 0.86)",
  easeExpoIn: "cubic-bezier(0.95, 0.05, 0.795, 0.035)",
  easeExpoOut: "cubic-bezier(0.19, 1, 0.22, 1)",
  easeExpoInOut: "cubic-bezier(1, 0, 0, 1)",
  easeQuadIn: "cubic-bezier(0.55, 0.085, 0.68, 0.53)",
  easeQuadOut: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
  easeQuadInOut: "cubic-bezier(0.455, 0.03, 0.515, 0.955)",
  easeQuartIn: "cubic-bezier(0.895, 0.03, 0.685, 0.22)",
  easeQuartOut: "cubic-bezier(0.165, 0.84, 0.44, 1)",
  easeQuartInOut: "cubic-bezier(0.77, 0, 0.175, 1)",
  easeQuintIn: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  easeQuintOut: "cubic-bezier(0.23, 1, 0.32, 1)",
  easeQuintInOut: "cubic-bezier(0.86, 0, 0.07, 1)",
  easeSineIn: "cubic-bezier(0.47, 0, 0.745, 0.715)",
  easeSineOut: "cubic-bezier(0.39, 0.575, 0.565, 1)",
  easeSineInOut: "cubic-bezier(0.445, 0.05, 0.55, 0.95)",
  easeBackIn: "cubic-bezier(0.6, -0.28, 0.735, 0.045)",
  easeBackOut: "cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  easeBackInOut: "cubic-bezier(0.68, -0.55, 0.265, 1.55)",
  easeBackOutMore: "cubic-bezier(0.56, 0.91, 0.465, 1.65)",
};

export default transition;
